export default "__VITE_ASSET__7df5a7e8__"